<script>
export default {
  data() {
    return {
      isVisible: false,
    };
  },
  methods: {
    toggleSwitcher() {
      this.isVisible = !this.isVisible;
    },

    /**
     * Onclick color change
     * @param theme theme color
     */
    setTheme(theme) {
      document
          .getElementById( "color-opt" )
          .setAttribute( "href", "./css/colors/" + theme + ".css" );
    },
  },
};
</script>


<template>
  <div>
    <!--START FOOTER-->
    <!--    <footer class="footer">-->
    <!--      <div class="container">-->
    <!--        <div class="row">-->
    <!--          <div class="col-lg-3 margin-t-20">-->
    <!--            <h4>DORSIN</h4>-->
    <!--            <div class="text-muted margin-t-20">-->
    <!--              <ul class="list-unstyled footer-list">-->
    <!--                <li>-->
    <!--                  <a href="javascript: void(0);">Home</a>-->
    <!--                </li>-->
    <!--                <li>-->
    <!--                  <a href="javascript: void(0);">About us</a>-->
    <!--                </li>-->
    <!--                <li>-->
    <!--                  <a href="javascript: void(0);">Careers</a>-->
    <!--                </li>-->
    <!--                <li>-->
    <!--                  <a href="javascript: void(0);">Contact us</a>-->
    <!--                </li>-->
    <!--              </ul>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--          <div class="col-lg-3 margin-t-20">-->
    <!--            <h4>Information</h4>-->
    <!--            <div class="text-muted margin-t-20">-->
    <!--              <ul class="list-unstyled footer-list">-->
    <!--                <li>-->
    <!--                  <a href="javascript: void(0);">Terms & Condition</a>-->
    <!--                </li>-->
    <!--                <li>-->
    <!--                  <a href="javascript: void(0);">About us</a>-->
    <!--                </li>-->
    <!--                <li>-->
    <!--                  <a href="javascript: void(0);">Jobs</a>-->
    <!--                </li>-->
    <!--                <li>-->
    <!--                  <a href="javascript: void(0);">Bookmarks</a>-->
    <!--                </li>-->
    <!--              </ul>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--          <div class="col-lg-3 margin-t-20">-->
    <!--            <h4>Support</h4>-->
    <!--            <div class="text-muted margin-t-20">-->
    <!--              <ul class="list-unstyled footer-list">-->
    <!--                <li>-->
    <!--                  <a href>FAQ</a>-->
    <!--                </li>-->
    <!--                <li>-->
    <!--                  <a href>Contact</a>-->
    <!--                </li>-->
    <!--                <li>-->
    <!--                  <a href>Disscusion</a>-->
    <!--                </li>-->
    <!--              </ul>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--          <div class="col-lg-3 margin-t-20">-->
    <!--            <h4>Subscribe</h4>-->
    <!--            <div class="text-muted margin-t-20">-->
    <!--              <p>In an ideal world this text wouldn’t exist, a client would acknowledge the importance of having web copy before the design starts.</p>-->
    <!--            </div>-->
    <!--            <form class="form subscribe">-->
    <!--              <input placeholder="Email" class="form-control" required />-->
    <!--              <a href="javascript: void(0);" class="submit">-->
    <!--                <i class="pe-7s-paper-plane"></i>-->
    <!--              </a>-->
    <!--            </form>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </footer>-->
    <!--END FOOTER-->

    <!--START FOOTER ALTER-->
    <!--    <div class="footer-alt">-->
    <!--      <div class="container">-->
    <!--        <div class="row">-->
    <!--          <div class="col-lg-12">-->
    <!--            <div class="float-left pull-none">-->
    <!--              <p class="copy-rights text-muted">{{ new Date().getFullYear()}} © Dorsin - Themesbrand</p>-->
    <!--            </div>-->
    <!--            <div class="float-right pull-none">-->
    <!--              <img src="@/assets/images/payment.png" alt="payment-img" height="36" />-->
    <!--            </div>-->
    <!--            <div class="clearfix"></div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--START FOOTER ALTER-->
    <!-- Style switcher -->
    <!--    <div id="style-switcher" :style="isVisible ? 'left: 0px' : 'left: -189px'">-->
    <!--      <div>-->
    <!--        <h3>Select your color</h3>-->
    <!--        <ul class="pattern">-->
    <!--          <li>-->
    <!--            <a class="color1" href="javascript: void(0);" v-on:click="setTheme('red')"></a>-->
    <!--          </li>-->
    <!--          <li>-->
    <!--            <a class="color2" href="javascript: void(0);" v-on:click="setTheme('green')"></a>-->
    <!--          </li>-->
    <!--          <li>-->
    <!--            <a class="color3" href="javascript: void(0);" v-on:click="setTheme('pink')"></a>-->
    <!--          </li>-->
    <!--          <li>-->
    <!--            <a class="color4" href="javascript: void(0);" v-on:click="setTheme('cyan')"></a>-->
    <!--          </li>-->
    <!--          <li>-->
    <!--            <a class="color5" href="javascript: void(0);" v-on:click="setTheme('purple')"></a>-->
    <!--          </li>-->
    <!--          <li>-->
    <!--            <a class="color6" href="javascript: void(0);" v-on:click="setTheme('blue')"></a>-->
    <!--          </li>-->
    <!--          <li>-->
    <!--            <a class="color7" href="javascript: void(0);" v-on:click="setTheme('orange')"></a>-->
    <!--          </li>-->
    <!--          <li>-->
    <!--            <a class="color8" href="javascript: void(0);" v-on:click="setTheme('yellow')"></a>-->
    <!--          </li>-->
    <!--        </ul>-->
    <!--      </div>-->
    <!--      <div class="bottom">-->
    <!--        <a href="javascript: void(0);" class="settings" @click="toggleSwitcher()">-->
    <!--          <i class="mdi mdi-settings mdi-spin"></i>-->
    <!--        </a>-->
    <!--      </div>-->
    <!--    </div>-->
    <!-- end Style switcher -->

    <footer class="footer-section">
      <div class="container pt-5 p-5 ">
        <div class="mb-5 text-center">
          <!--          <h2 class="text-white font-weight-bold mt-3">{{ $t( "home.company" ) }}</h2>-->
        </div>

        <div class="footer-social-icon single-cta text-center">
          <span style="font-size: 26px">Bizning manzillar</span>
        </div>
        <div class="footer-cta pb-5">
          <div class="row">
            <div class="col-xl-4 col-md-4 mb-30">
              <div class="single-cta">

                    <div class="cta-text float-left text-center">
                      <h4>Elektron pochta manzil</h4>
                      <span>info@adliya.uz</span>
                    </div>


              </div>
            </div>
            <div class="col-xl-4 col-md-4 mb-30">
              <div class="single-cta">

                    <div class="cta-text float-left text-center">
                      <h4>Telefon: </h4>
                      <span> Yuridik xizmatlarning faoliyatini muvofiqlashtirish boshqarmasi</span><br>
                      <span>998 71 207 04 53</span>
                    </div>


              </div>
            </div>
            <div class="col-xl-4 col-md-4 mb-30">
              <div class="single-cta">

                    <div class="cta-text float-left text-center">
                      <h4>Yuridik manzil</h4>
                      <span>5 Sayilgoh ko'chasi, Тошкент 100047</span>
                    </div>
              </div>
            </div>
          </div>
        </div>


      </div>

    </footer>
  </div>
</template>

<style scoped>

.footer-section {
  background: #151414;
  position: relative;
}

.footer-cta {
  border-bottom: 1px solid #373636;
}

.single-cta {
  text-align: center;
  padding-bottom: 50px;
}

.single-cta i {
  color: #ff5e14;
  font-size: 30px;
  margin-top: 8px;
}

.cta-text {
  padding-left: 15px;
  display: inline-block;
}

.cta-text h4 {
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 2px;
}

.cta-text span {
  color: #fff;
  font-size: 15px;
}

.footer-pattern img {
  position: absolute;
  top: 0;
  left: 0;
  height: 330px;
  background-size: cover;
  background-position: 100% 100%;
}

.footer-logo {
  margin-bottom: 30px;
}

.footer-logo img {
  max-width: 200px;
}

.footer-text p {
  margin-bottom: 14px;
  font-size: 14px;
  color: #7e7e7e;
  line-height: 28px;
}

.footer-social-icon span {
  color: #fff;
  display: block;
  font-size: 20px;
  font-weight: 700;
  font-family: 'Poppins', sans-serif;
  margin-bottom: 20px;
}

.footer-social-icon a {
  color: #fff;
  font-size: 16px;
  margin-right: 15px;
}

.footer-social-icon i {
  height: 40px;
  width: 40px;
  text-align: center;
  line-height: 38px;
  border-radius: 50%;
}

.footer-widget-heading h3 {
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 40px;
  position: relative;
}

.footer-widget-heading h3::before {
  content: "";
  position: absolute;
  left: 0;
  bottom: -15px;
  height: 2px;
  width: 50px;
  background: #ff5e14;
}

.footer-widget ul li {
  display: inline-block;
  float: left;
  width: 50%;
  margin-bottom: 12px;
}

.footer-widget ul li a:hover {
  color: #ff5e14;
}

.footer-widget ul li a {
  color: #878787;
  text-transform: capitalize;
}

.subscribe-form input {
  width: 100%;
  padding: 14px 28px;
  background: #2E2E2E;
  border: 1px solid #2E2E2E;
  color: #fff;
}

.subscribe-form button {
  position: absolute;
  right: 0;
  background: #ff5e14;
  padding: 13px 20px;
  border: 1px solid #ff5e14;
  top: 0;
}

.subscribe-form button i {
  color: #fff;
  font-size: 22px;
  transform: rotate(-6deg);
}

.copyright-text p {
  margin: 0;
  font-size: 14px;
  color: #878787;
}

.copyright-text p a {
  color: #ff5e14;
}

.footer-menu li {
  display: inline-block;
  margin-left: 20px;
}

.footer-menu li:hover a {
  color: #ff5e14;
}

.footer-menu li a {
  font-size: 14px;
  color: #878787;
}

.footer-section {
  position: absolute;
  width: 100%;
  height: 70vh;
  background-position: center;
  background-size: cover;
  background-image: linear-gradient(rgba(0, 0, 100, 0.6), rgba(0, 0, 100, 0.7)), url("../assets/adliya_footer.jpg");
  box-sizing: border-box;
}

@media (min-width: 280px) {
  .footer-section {
    height: 125vh;
  }
}

@media (min-width: 320px) {
  .footer-section {
    height: 145vh;
  }
}

@media (min-width: 360px) {
  .footer-section {
    height: 125vh;
  }
}

@media (min-width: 375px) {
  .footer-section {
    height: 110vh;
  }
}

@media (min-width: 411px) {
  .footer-section {
    height: 120vh;
  }
}

@media (min-width: 576px) {
  .footer-section {
    height: 100vh;
  }
}

@media (min-width: 768px) {
  .footer-section {
    height: 60vh;
  }
}

@media (min-width: 992px) {
  .footer-section {
    height: 70vh;
  }
}

@media (min-width: 912px) {
  .footer-section {
    height: 85vh;
  }
}

@media (min-width: 1024px) {
  .footer-section {
    height: 70vh;
  }
}

@media (min-width: 1200px) {
  .footer-section {
    height: 70vh;
  }
}

</style>
